import { useQuery } from "@tanstack/react-query";
import calendarEventApiClient, {
  CalendarEvent,
  KLYDO_EVENT_PRIMARY_TYPE,
} from "../../../api/calendarEvent";

// A day can hold at most one Klydo Event. This returns the existing Klydo Event
// scheduled on the given date (or null), so callers can block adding a second.
const useKlydoEventForDate = (date: Date, enabled = true) => {
  return useQuery<CalendarEvent | null>({
    queryKey: [
      "calendar-events-by-date",
      date.getFullYear(),
      date.getMonth() + 1,
      date.getDate(),
    ],
    queryFn: async () => {
      const events = await calendarEventApiClient.getCalendarEvents({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      });
      return (
        events.find((e) => e.primaryType === KLYDO_EVENT_PRIMARY_TYPE) ?? null
      );
    },
    enabled,
  });
};

export default useKlydoEventForDate;
